'use client';

import CalculatorBase from '@/components/calculator/CalculatorBase';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { RichText } from '@/components/richText/RichText';
import { shouldShowCalculatorStoryFooter } from '@/helper/calculatorFooter';
import { ProductCategory, TargetGroup } from '@/helper/enums';
import { stringToEnum } from '@/helper/utils';
import classes from '@/storyblok/calculator/Calculators.module.scss';
import type { GlobalGasRechnerStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

const CalculatorGasProxy: React.FC<{
  blok: GlobalGasRechnerStoryblok;
  hideTitle?: boolean;
  hideFooter?: boolean;
  tag?: HeadlineTag;
  calculatorStoryId?: string;
}> = ({ blok, hideTitle = false, hideFooter = false, tag = HeadlineTag.H2, calculatorStoryId }) => {
  return (
    <div {...storyblokEditable(blok)}>
      {blok.title && !hideTitle && (
        <HeadlineField className={classes.calculatorMainTitle} tag={tag} style={HeadlineTag.H4}>
          {blok.title}
        </HeadlineField>
      )}
      <CalculatorBase
        type={ProductCategory.Gas}
        button={blok.button}
        spc={blok.spcConfig && blok.spcConfig[0]}
        targetGroup={stringToEnum(TargetGroup, blok.target_group)}
        calculatorStoryId={calculatorStoryId}
      />
      {shouldShowCalculatorStoryFooter(blok.text, { hideFooter, hideFooterText: blok.hide_footer_text }) && (
        <RichText className={classes.calculatorFooter} text={blok.text} />
      )}
    </div>
  );
};

export default CalculatorGasProxy;
